import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isOperatorMcpConnection = objectOf({
  id: string,
  name: string,
  display_name: string,
  server_url: string,
  client_id: anyOf(string, nullOrUndefined),
  has_client_secret: boolean,
  created_at: string,
  updated_at: string,
  last_edited_by_name: anyOf(string, nullOrUndefined),
  connected: boolean,
});

export const isGetAppGroupIdOperatorMcpConnectionsResult = objectOf({
  connections: arrayOf(isOperatorMcpConnection),
  callback_url: string,
});
